<template>    
    <div v-if="kernel_list">
        <v-card v-for="(kernel, index) in kernel_list" :key="index" outlined>
            <v-card-text>
                <v-layout row wrap>
                    <v-flex xs12>
                        {{kernel}}
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import config from '../../config.js'
import axios from '../../axios-auth'

export default {
    data() {
        return {
            kernel_list: null,
            myconfig : {   
                headers: { "Content-Type": "text/plain"},
                "Access-Control-Allow-Origin": "*",                                       
            }
        }
    },
    mounted() {
        this.initData()       
    },
    methods: {
        initData() {
            this.refreshKernels()
            this.kernel = this.$store.getters.getCodeForRunKernel
        },
        refreshKernels() {
            axios.get(config.baseKernelGatewayURL+'/api/kernels?token=G69s43LMfReKj_kqtdAVrAtiPbprRloAfE1fqp0eVAJ-IChQcV-kv3gW-gBAzWztBEdFY', this.myconfig)
            .then((res) => {
                this.kernel_list = res.data //.kernel
                console.log(this.kernel_list)
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)
            })           
        },
        deleteKernel(_id) {
            axios.delete(config.baseKernelGatewayURL+'/api/kernels/'+this.kernel.id+'?token=G69s43LMfReKj_kqtdAVrAtiPbprRloAfE1fqp0eVAJ-IChQcV-kv3gW-gBAzWztBEdFY', {}, this.myconfig)
            .catch(error => {
                this.$store.commit('setFeedback', error)
            })
        },
    }
}

</script>

